import Immutable from 'immutable';

import Url from 'sharedreact/data/Url';
import { translate } from 'sharedreact/utils/LanguageSupport';

const Content: {
  url: Url,
  page: number,
  image: string | null
} = {
  url: new Url(),
  page: -1,
  image: null
};

class PagePreview extends Immutable.Record(Content) {
  get id (): string {
    return this.page.toString();
  }
  get name (): string {
    return translate('shared.data.pagepreview.page', this.page + 1);
  }
}

export default PagePreview;
